import { createBrowserRouter } from 'react-router-dom';
import { protectedLoader, requireModule } from './auth/guards';
import { MODULES } from './auth/permissions';
import PublicLayout from './layouts/PublicLayout';
import RootLayout from './layouts/RootLayout';
import { accountingRoutes } from './modules/accounting/accounting.routes';
import { accountsRoutes } from './modules/accounts/accounts.routes';
import { adminRoutes } from './modules/admin/admin.routes';
import { authRoutes } from './modules/auth/auth.routes';
import { dashboardRoutes } from './modules/dashboards/dashboards.routes';
import { filesRoutes } from './modules/files/files.routes';
import { protectedHiringRoutes, publicHiringRoutes } from './modules/hiring/hiring.routes';
import HomeByRole from './modules/home/HomeByRole';
import { hrRoutes } from './modules/hr/hr.routes';
import { payrollRoutes } from './modules/payroll/payroll.routes';
import { taskRoutes } from './modules/tasks/tasks.routes';
import { websiteRoutes } from './modules/website/website.routes';
import { workRoutes } from './modules/work-implementation/work.routes';
import { NotFoundPage } from './pages';
import AdminDataManagement from './pages/AdminDataManagement';
import UnauthorizedPage from './pages/UnauthorizedPage';

const router = createBrowserRouter([
  authRoutes,
  {
    element: <PublicLayout />,
    children: [...publicHiringRoutes],
  },
  {
    element: <RootLayout />,
    loader: protectedLoader,
    children: [
      { path: '/', element: <HomeByRole /> },
      {
        path: '/update-data',
        element: <AdminDataManagement />,
        handle: { breadcrumb: 'News & Updates' },
        loader: requireModule(MODULES.NEWS),
      },
      ...dashboardRoutes,
      ...protectedHiringRoutes,
      ...hrRoutes,
      ...payrollRoutes,
      ...workRoutes,
      ...taskRoutes,
      ...adminRoutes,
      ...accountsRoutes,
      ...accountingRoutes,
      ...filesRoutes,
      ...websiteRoutes,


      // { path: '/jobs', element: <Dashboard /> },
      // { path: '/dashboard', element: <AdminDashboard /> },
      // { path: '/jobs', element: <ComingSoon /> },
      // { path: '/jobs/*', element: <ComingSoon /> },
      // { path: '/employees', element: <EmployeesPage /> },
      // { path: '/letters-certificates', element: <LettersCertificatesPage /> },
      // { path: '/credits', element: <CreditsPage /> },
      // { path: '/credits/view/:id', element: <CreditsView /> },
      // { path: '/debits', element: <DebitsPage /> },
      // { path: '/update-data', element: <DataUpdatePage /> },
      // { path: '/jobs/edit/:id', element: <AddJobForm isEdit /> },
      { path: '/unauthorized', element: <UnauthorizedPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  // { path: '/drawing-confirmation', element: <DrawingConfirmationPage /> },
  // { path: '/document-collection', element: <DocumentCollectionPage /> },
]);

export default router;
